import { Reveal } from "../components/Reveal";
import { IMG } from "../data/images";
import { useLang } from "../i18n";

const MEDIA = [
  { img: IMG.waffle, name: "bubble-waffle.webp", price: "5.00 €" },
  { img: IMG.matcha, name: "matcha-latte.webp", price: "4.50 €" },
  { img: IMG.crepe, name: "tostada-aguacate.webp", price: "4.90 €" },
  { img: IMG.bagel, name: "bocadillo-huevo.webp", price: "6.20 €" },
];

export const Highlights = () => {
  const { t } = useLang();
  const cards = MEDIA.map((m, i) => ({ ...m, ...t.highlights.cards[i] }));

  return (
    <section id="favoritos" data-testid="highlights-section" className="bg-[#F5EDE3] px-6 py-24 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <Reveal>
              <p className="label text-[#8A6A4F]">{t.highlights.label}</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 max-w-[18ch] font-serif text-4xl font-light leading-[1.06] text-[#2B1E16] sm:text-5xl lg:text-6xl">
                {t.highlights.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-[30ch] font-sans text-sm text-[#2B1E16]/60">{t.highlights.intro}</p>
          </Reveal>
        </div>

        <div className="v1-favorites-rail mt-16 grid gap-x-8 gap-y-14 sm:grid-cols-2 md:mt-24 lg:grid-cols-4">
          {cards.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.08} className="v1-favorite-slide">
              <article data-testid={`highlight-card-${i}`} className="v1-favorite-card group">
                <div className="relative overflow-hidden bg-[#2B1E16]/10">
                  <img
                    src={c.img}
                    alt={c.t}
                    data-placeholder-name={c.name}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover transition-transform duration-[2200ms] ease-out group-hover:scale-[1.07]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2B1E16]/60 via-transparent to-transparent opacity-70" />
                  <span className="absolute start-4 top-4 bg-[#2B1E16]/85 px-3 py-1.5 font-sans text-[9px] uppercase tracking-[0.24em] text-[#D9B98A]">
                    {c.k}
                  </span>
                </div>
                <div className="mt-6 flex items-baseline gap-3">
                  <h3 className="font-serif text-2xl leading-tight text-[#2B1E16]">{c.t}</h3>
                  <span className="mb-1 flex-1 border-b border-dotted border-[#2B1E16]/25" />
                  <span className="font-sans text-xs text-[#8A6A4F]">{c.price}</span>
                </div>
                <p className="mt-3 font-sans text-sm leading-relaxed text-[#2B1E16]/60">{c.d}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
